import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable()
export class DashboardMenuTabSelectorService {
    private mSelectedTab: number;

    private selectedTabChangedSource: Subject<number>;
    public readonly selectedTabChanged: Observable<number>;

    constructor() {
        this.selectedTabChangedSource = new Subject<number>();
        this.selectedTabChanged = this.selectedTabChangedSource.asObservable();
    }

    public get selectedTab(): number {
        return this.mSelectedTab;
    }

    public set selectedTab(index: number) {
        this.mSelectedTab = index;
        this.selectedTabChangedSource.next(index);
    }
}